export { aggregatedRowsPlugin } from './src/index';
